import { Link } from "react-router-dom";
import { AlertCircle, Sparkles, BadgeCheck } from "lucide-react";

function fmtFullDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export default function TrialBanner({ user }) {
  if (!user) return null;

  // Solo · renewing soon (≤5 days from solo_until)
  if (
    user.tier === "solo" &&
    user.solo_days_left !== undefined &&
    user.solo_days_left !== null &&
    user.solo_days_left <= 5
  ) {
    return (
      <div
        data-testid="trial-banner-solo-renew"
        className="bg-[#ECFDF5] border-b border-[#A7F3D0]"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <BadgeCheck className="w-4 h-4 flex-shrink-0 text-[#059669]" />
            <span className="font-figtree text-xs sm:text-sm text-[#065F46]">
              <strong>Solo through {fmtFullDate(user.solo_until)}</strong> ·
              renew now to avoid interruption (
              {user.solo_days_left} day
              {user.solo_days_left === 1 ? "" : "s"} left).
            </span>
          </div>
          <Link
            to="/account"
            data-testid="trial-banner-solo-renew-cta"
            className="inline-flex items-center px-3 py-1 rounded-full bg-[#065F46] text-white text-xs font-semibold hover:bg-[#047857] whitespace-nowrap"
          >
            Subscriptions coming soon
          </Link>
        </div>
      </div>
    );
  }

  // Expired — red bar that gates writes
  if (user.tier === "trial" && user.trial_expired) {
    return (
      <div
        data-testid="trial-banner-expired"
        className="bg-[#7F1D1D] text-white"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <AlertCircle className="w-4 h-4 flex-shrink-0 text-[#FCA5A5]" />
            <span className="font-figtree text-xs sm:text-sm">
              <strong>Trial expired.</strong> Existing notes are still viewable.
              Subscribe to keep saving new ones.
            </span>
          </div>
          <Link
            to="/account"
            data-testid="trial-banner-expired-cta"
            className="inline-flex items-center px-3 py-1 rounded-full bg-white text-[#7F1D1D] text-xs font-semibold hover:bg-[#FECACA] whitespace-nowrap"
          >
            Subscriptions coming soon
          </Link>
        </div>
      </div>
    );
  }
  // Soft warning at ≤5 days
  if (user.tier === "trial" && user.trial_days_left !== null && user.trial_days_left <= 5) {
    return (
      <div
        data-testid="trial-banner-warning"
        className="bg-[#FEF3C7] border-b border-[#FDE68A]"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <Sparkles className="w-4 h-4 flex-shrink-0 text-[#B45309]" />
            <span className="font-figtree text-xs sm:text-sm text-[#78350F]">
              <strong>{user.trial_days_left} day{user.trial_days_left === 1 ? "" : "s"} left</strong>{" "}
              in your free trial.
            </span>
          </div>
          <Link
            to="/account"
            data-testid="trial-banner-warning-cta"
            className="inline-flex items-center px-3 py-1 rounded-full bg-[#78350F] text-white text-xs font-semibold hover:bg-[#92400E] whitespace-nowrap"
          >
            Subscriptions coming soon
          </Link>
        </div>
      </div>
    );
  }
  return null;
}
